import { Provider } from "react-redux";
import { Navigator } from "./pages/navigator";
import { Store } from "./redux/store";

const App = () => (
	<Provider store={Store}>
		<Navigator />
	</Provider>
);

export default App;
